import {
    useSymboInfo,
    useSymbolInUsersSymbology,
} from 'symbols/symbolInfo/hooks';
import { SymbologyValues } from 'app/store/appSettings/AppSettingsState';
import { FillsGraphDataState } from 'widgets/fillsGraph/store/data/FillsGraphDataState';

export function useFillsGraphDataIndex(streamData?: FillsGraphDataState) {
    const orderStatData = streamData?.orderStat;
    return useSymboInfo(orderStatData?.indexSym, SymbologyValues.Instinet);
}

export function useFillsGraphDataIndexDescription(
    streamData?: FillsGraphDataState
) {
    const orderStatData = streamData?.orderStat;
    const indexSymbolInfo = useFillsGraphDataIndex(streamData);
    return indexSymbolInfo?.description ?? orderStatData?.indexSym;
}

export function useFillsGraphDataIndexUserSymbology(
    streamData?: FillsGraphDataState
) {
    const orderStatData = streamData?.orderStat;
    return useSymbolInUsersSymbology(
        orderStatData?.indexSym,
        SymbologyValues.Instinet
    );
}
